import cx from "clsx";
import { FileHandle } from "kreate-common/modules/business-types";
import { blobIdToUrl } from "kreate-env/client";
import React from "react";

import { ImageViewer } from "../../../ImageViewer";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  file: FileHandle | null | undefined;
  fill: true;
  sizes: string | undefined;
};

export default function PrimaryImageViewer({
  className,
  style,
  file,
  sizes,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      {!file ? undefined : file.blob.contentType === "image/svg+xml" ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          className={styles.image}
          src={blobIdToUrl(file.blob.blobId)}
          alt=""
          decoding="async"
        />
      ) : (
        <ImageViewer
          style={{ backgroundColor: "transparent" }}
          value={file}
          sizing="fill"
          objectFit="contain"
          sizes={sizes}
        />
      )}
    </div>
  );
}
